import * as React from 'react';
import * as Glob from '../Globale';
import { NavLink, Link } from 'react-router-dom';
import { BasePureComponent } from './BaseComponent';
import { ChiamaAPI, Trad, Tipo } from './';
import * as Dati from '../Dati';

interface ICheckListFileProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON; //JSON Documenti
    ID_TipoFileRichiesto: string; //tipologia del contesto per recuperare le info dei file necessari
    ChiaviRecupero: Glob.DatiJSON | number[]; //JSON entità per il recupero dei documenti presenti
    Validato: boolean;
    ID_Chiave: number;
    Aggiornare?: number;
}

export class CheckListFile extends BasePureComponent<ICheckListFileProps> {

    private _Dati: Dati.CDatiCheckListFile = new Dati.CDatiCheckListFile();
    private _Tipologia: Dati.TDictTipo = {};
    private _ChiaviRecupero: number[] = [];
    private _Abilitato: boolean = false;
    //private _TipoRecpapito: Dati.TDictTipo = {};

    public constructor(props: any) {
        super(props);

        this.OnErrore = this.OnErrore.bind(this);
    }

    private PopolaDati() {
        if (typeof (this.props.ChiaviRecupero) == "string") {
            this._ChiaviRecupero = JSON.parse(this.props.ChiaviRecupero);
        }
        else {
            this._ChiaviRecupero = this.props.ChiaviRecupero;
        }

        if (this.props.Value != undefined && this.props.Value != "") {
            let DatiApp: Dati.CDatiCheckListFileBase = JSON.parse(this.props.Value);
            for (let i: number = 0; i < DatiApp.FileCaricati.length; i++) {
                for (let x: number = 0; x < this._Dati.FileCaricati.length; x++) {
                    if (this._Dati.FileCaricati[x].ID_File == DatiApp.FileCaricati[i].ID_File)
                        this._Dati.FileCaricati[x].Selezionato = true;
                }
            }
            this._Dati.Note = DatiApp.Note;
            this._Dati.Validato = DatiApp.Validato;
        }

        this.Controllo();
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIListaFileChecklist, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this._Dati.FileCaricati = dati.Dati;
            this.forceUpdate();
        }

        return false;
    }

    private ControlloSwitch(stato: string) {
        switch (stato) {
            case Glob.Tipi_FS_Caricato:
                return false;
            case Glob.Tipi_FS_Validato:
                return true;
        }
        return false;
    }

    private OnAggiornaSelezionato(i: number, selezionato?: boolean) {
        if (selezionato == undefined)
            this._Dati.FileCaricati[i].Selezionato = !this._Dati.FileCaricati[i].Selezionato;
        else
            this._Dati.FileCaricati[i].Selezionato = selezionato;

        if (this._Dati.FileCaricati[i].Selezionato && this._Dati.FileCaricati[i].Necessario) {
            for (let x: number = 0; x < this._Dati.FileCaricati.length; x++) {
                if (this._Dati.FileCaricati[x].Tipo == this._Dati.FileCaricati[i].Tipo && x != i) {
                    this._Dati.FileCaricati[x].Selezionato = false;
                    this._Dati.FileCaricati[x].Necessario = false;
                }
            }
        } else if (!this._Dati.FileCaricati[i].Selezionato && this._Dati.FileCaricati[i].Necessario) {
            for (let x: number = 0; x < this._Dati.FileCaricati.length; x++) {
                if (this._Dati.FileCaricati[x].Tipo == this._Dati.FileCaricati[i].Tipo) {
                    this._Dati.FileCaricati[x].Necessario = this._Dati.FileCaricati[i].Necessario;
                }
            }
        }

        if (this._Dati.FileCaricati[i].Necessario && !selezionato) {
            this._Dati.Validato = false;
            this._Abilitato = false;
        }

        this.Controllo();
        this.OnAggiorna();
        //effettua update;
    }

    private OnAggiornaValidato(i: number): any {
        let URL: string = "/api/file/ValidaFile?sessione=" + Glob.GetSessione().Sessione + "&id_file=" + this._Dati.FileCaricati[i].ID_File + "&ID_Chiave=" + this.props.ID_Chiave + "&valida=";
        switch (this._Dati.FileCaricati[i].ID_TipoFileStato) {
            case Glob.Tipi_FS_Caricato:
                URL = URL + "true";
                break;
            case Glob.Tipi_FS_Validato:
                URL = URL + "false"
                break;
        }

        fetch(URL)
            .then(response => {
                if (response.ok) {
                    response.text().then(text => {
                        let data = JSON.parse(text, Glob.DateReviver);
                        if (data.Errore)
                            Glob.InfoModaleError("ERRORE: ", data.ErrTesto);
                        else {
                            Glob.InfoModaleSuccess("SUCCESS", Trad.Trad("Documento validato correttamente"));
                            switch (this._Dati.FileCaricati[i].ID_TipoFileStato) {
                                case Glob.Tipi_FS_Caricato:
                                    this._Dati.FileCaricati[i].ID_TipoFileStato = Glob.Tipi_FS_Validato;
                                    this.OnAggiornaSelezionato(i, true);
                                    break;
                                case Glob.Tipi_FS_Validato:
                                    this._Dati.FileCaricati[i].ID_TipoFileStato = Glob.Tipi_FS_Caricato;
                                    this.OnAggiornaSelezionato(i, false);
                                    break;
                            }
                        }
                    }).catch(e => {
                        Glob.InfoModaleError("ERROR", e);
                    });
                }
                else {
                    Glob.InfoModaleError("ERRORE", "Errore caricamento");
                }
            })
            .catch(e => {
                //Glob.Log(Glob.LogCat.API, true, "Errore caricamento BottoneAPI (" + this.props.Nome + "): " + this.props.URL + " (Rete)", e);
            });

        this.OnAggiorna();
        //effettua update;
    }

    private OnAggiornaAbilitato(): any {
        if (this._Abilitato) {
            this._Dati.Validato = !this._Dati.Validato;
            this.forceUpdate();
        } else {
            Glob.InfoModaleWarning("WARNING", Trad.Trad("Non tutti i file necessari sono stati selezionati e validati"));
        }

        this.OnAggiorna();
        //effettua update;
    }

    private OnAggiornaNote(e: React.FormEvent<any>): any {
        this._Dati.Note = e.currentTarget.value;
        this.OnAggiorna();
        this.forceUpdate();
    }

    protected OnAggiorna(): any {
        let appDati: Dati.CDatiCheckListFileBase = new Dati.CDatiCheckListFileBase();
        appDati.Note = this._Dati.Note;
        appDati.Validato = this._Dati.Validato;
        appDati.FileCaricati = [];
        for (let i: number = 0; i < this._Dati.FileCaricati.length; i++) {
            if (this._Dati.FileCaricati[i].Selezionato)
                appDati.FileCaricati.push(new Dati.CDatiFileCheckListBase(this._Dati.FileCaricati[i].ID_File));
        }
        this.props.OnChange(this.props.Name, JSON.stringify(appDati));
    }

    private RestituisciIcona(tipo: string, id_file: number): string {
        if (id_file > 0)
            return Glob.RestituisciIcona(tipo);
        else
            return "fa fa-plus";
    }

    private ColoreSfondo(dato: Dati.CDatiFileCheckList): string {
        if (dato.Necessario && dato.ID_File == 0)
            return "form-group kt-form login-form__group little row kt--bg-danger";
        else if (dato.Necessario && (dato.ID_TipoFileStato == Glob.Tipi_FS_Caricato || dato.ID_TipoFileStato == Glob.Tipi_FS_Validato && !dato.Selezionato))
            return "form-group kt-form login-form__group little row kt--kt-portlet__head";
        else if (dato.Necessario && dato.ID_TipoFileStato == Glob.Tipi_FS_Validato && dato.Selezionato)
            return "form-group kt-form login-form__group little row kt--bg-success";
        else
            return "form-group kt-form login-form__group little row";
    }

    private ColoreSfondoTestata(validato: boolean): string {
        if (validato)
            return "kt-portlet bg-fill-success kt-portlet--head-solid-bg kt-portlet--bordered";
        else
            return "kt-portlet bg-fill-warning black kt-portlet--head-solid-bg kt-portlet--bordered";
    }

    private Controllo() {
        this._Abilitato = true;
        for (let i: number = 0; i < this._Dati.FileCaricati.length; i++) {
            if (this._Dati.FileCaricati[i].Necessario && (this._Dati.FileCaricati[i].ID_TipoFileStato == Glob.Tipi_FS_Caricato || !this._Dati.FileCaricati[i].Selezionato))
                this._Abilitato = false;
        }
        //this.props.OnChange(this.props.Name, JSON.stringify(this._Dati));
        //this.forceUpdate();
    }

    private CheckListVisibile(): string {
        if (this.props.Visibile != undefined && !this.props.Visibile) 
            return "hidden";
        else
            return "";
    }

    public render() {
        this.PopolaDati();
        let valori: any[] = [];
        for (let i: number = 0; i < this._Dati.FileCaricati.length; i++) {
            let azioni: any[] = [];
            if (this._Dati.FileCaricati[i].ID_File > 0) {
                azioni.push(<div className="col-lg-5 col-md-12 col-sm-12" key={i + 1}>
                    <a className="special" href={"/api/file/scarica?id_file=" + this._Dati.FileCaricati[i].ID_File + "&sessione=" + Glob.GetSessione().Sessione} target="_blank">
                        {this._Dati.FileCaricati[i].NomeFile}</a>
                </div>);
                azioni.push(<div className="col-lg-2 col-md-12 col-sm-12" key={i + 2}>
                    <span className="kt-switch kt-switch--sm kt-switch--icon">
                        <label>{Trad.Trad("Validato")}
                            <input name="" type="checkbox" checked={this.ControlloSwitch(this._Dati.FileCaricati[i].ID_TipoFileStato)} onChange={() => this.OnAggiornaValidato(i)} />
                            <span></span>
                        </label>
                    </span>
                </div>);
                azioni.push(<div className="col-lg-2 col-md-12 col-sm-12" key={i + 3}>
                    <label className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">{Trad.Trad("Selezionato")}
                        <input name="" type="checkbox" checked={this._Dati.FileCaricati[i].Selezionato} onChange={() => this.OnAggiornaSelezionato(i)} />
                        <span></span>
                    </label>
                </div>);
            }

            valori.push(<div className={this.ColoreSfondo(this._Dati.FileCaricati[i])} key={i}>
                <div className="col-lg-1 col-md-4 col-sm-4">
                    <NavLink to={"/file/" + this.props.ID_Chiave + "/" + this._Dati.FileCaricati[i].ID_File} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-xl special" title={Trad.Trad("Modifica")}>
                        <i className={this.RestituisciIcona(this._Dati.FileCaricati[i].Tipo, this._Dati.FileCaricati[i].ID_File)}></i>
                    </NavLink>
                </div>
                <div className="col-lg-2 col-md-8 col-sm-8">
                    {this._Dati.FileCaricati[i].Tipo}
                </div>
                {azioni}
            </div>);
        }
        //<a href="#" onClick={(e) => { e.preventDefault(); this.OnAggiungi() }} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-xl" title={Trad.Trad("Nuovo recapito")}>
        //    <i className="fa fa-plus"></i>
        //</a>
        return <div className={this.ColoreSfondoTestata(this._Dati.Validato) + " " + this.CheckListVisibile()}>
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-archive"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Documenti")}
                        </h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <li className="kt-portlet__nav-item">
                            <span className="kt-switch kt-switch--sm kt-switch--icon">
                                <label>
                                    <input name="_Validato" type="checkbox" checked={this._Dati.Validato} onChange={() => { this.OnAggiornaAbilitato(); }} />
                                    <span></span>
                                </label>
                            </span>
                        </li>
                        <li className="kt-portlet__nav-item">
                            <NavLink to={"/file/" + this.props.ID_Chiave + "/0"} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-xl" title={Trad.Trad("Nuovo")}>
                                <i className="fa fa-plus"></i>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="kt-portlet__body noborder">
                {valori}
                <div className="form-group kt-form login-form__group row">
                    <div className="col-lg-12">
                        <label className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">
                            {Trad.Trad("Note")}
                        </label>
                        <textarea className="form-control" value={this._Dati.Note} onChange={(e) => this.OnAggiornaNote(e)} />
                    </div>
                </div>
            </div>
            <ChiamaAPI Aggiornare={this.props.Aggiornare != undefined ? this.props.Aggiornare + this.props.ID_TipoFileRichiesto.length : this.props.ID_TipoFileRichiesto.length} URL={"/api/File/SelezionaFile?chiavi=" + this._ChiaviRecupero + "&ID_TipoFileRichiesto=" + this.props.ID_TipoFileRichiesto} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
        </div >;
    }
}



// WEBPACK FOOTER //
// ./src/components/CheckListFile.tsx